<template>
  <div class="mobile-person-swiper-box">
    <el-carousel indicator-position="outside" arrow="never" height="90rem">
      <el-carousel-item v-for="(item, index) in swiperList" :key="index">
        <div class="mobile-person-swiper-wrap">
          <div
            class="mobile-person-swiper-item"
            v-for="(personItem, personIndex) in item"
            :key="personIndex"
          >
            <div class="mobile-person-icon-box">
              <img
                :src="getImgUrl(personItem.thumb)"
                class="mobile-icon hvr-grow"
                alt=""
              />
            </div>
            <div class="mobile-title">{{ personItem.title }}</div>
            <div
              class="mobile-swiper-text slhf"
              v-html="personItem.content"
            ></div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    teamList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    swiperList() {
      return _.chunk(this.teamList, 4);
    },
  },
  methods: {
    getPerson(index) {
      return require(`@/assets/team/person${index}.png`);
    },
    getName(index) {
      switch (index) {
        case 1:
          return "史红霞";
        case 2:
          return "刘明魁";
        case 3:
          return "张华超";
        case 4:
          return "刘晨";
      }
    },
    getText(index) {
      switch (index) {
        case 1:
          return "战略合作伙伴";
        case 2:
          return "技术合伙人";
        case 3:
          return "技术合伙人";
        case 4:
          return "高级PHP工程师";
      }
    },
  },
};
</script>

<style scoped>
.slhf {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box !important;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.mobile-person-swiper-box {
  padding: 5rem 0 0;
}

.mobile-person-swiper-wrap {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 0 2.5rem;
  width: 100%;
}

.mobile-person-swiper-wrap .mobile-person-swiper-item {
  width: 48%;
  margin-right: 0;
  margin-bottom: 3rem;
}

.mobile-person-swiper-wrap .mobile-person-swiper-item .mobile-person-icon-box {
  width: 20rem;
  height: 27.625rem;
  overflow: hidden;
}

.mobile-person-swiper-wrap
  .mobile-person-swiper-item
  .mobile-person-icon-box
  .mobile-icon {
  width: 100%;
}

.mobile-person-swiper-wrap .mobile-person-swiper-item .mobile-title {
  font-weight: 300;
  font-size: 1.75rem;
  color: #ffffff;
  margin: 1.9375rem 0 1.25rem 0;
}

.mobile-person-swiper-wrap .mobile-person-swiper-item .mobile-swiper-text {
  font-weight: 300;
  font-size: 1.5rem;
  color: #ffffff;
  opacity: 0.3;
}
</style>
